import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Step04SVG  from "itd-common/assets/images/onboarding/tutorial_step_04.png";
import "./authAside.scss"

const T_PREFIX: string = 'pages.authAside.2FA.';

const Code2FA: React.FC = () => {
  const { t } = useTranslation();

    return (
        <div className="platform-section" style={{ maxWidth: `23rem`  }}>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}title1`)}</span>  {t(`${T_PREFIX}title2`)}
                    </h1>
                </div>
                <div className="row wrap_content">
                    <div className="col-md-6">
                        <div className="platform-step my-2">
                            <div className='d-inline-block'>
                                <h3 className='fs-6 fw-bold'>{t(`${T_PREFIX}enterCode`)}</h3>
                            </div>
                        </div>
                        <div className="platform-step mb-2">
                            <small className="fs-7">{t(`${T_PREFIX}description`)}</small>
                            <div className='d-inline-block'>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">    
                        <img src={Step04SVG} alt="Tutorial Step 01" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default (Code2FA);